import React, {useEffect, useState} from 'react';
import Select from "react-select";
import {Controller} from 'react-hook-form';


export default function ({
                           label,
                           name,
                           control,
                           errorMessage,
                           options = [],
                           placeholder = 'აირჩიეთ',
                           className = '',
                           inputClassName = '',
                           optionLabel = "name",
                           optionValue = "id",
                           defaultValue = "",
                           callback = null,
                           required = false,
                           clearable = true
                         }) {

  const [selectedValue, setSelectValue] = useState(null);

  const handleChange = (selected, onChange) => {
    const value = selected ? selected[optionValue] : null;
    onChange(value);
    setSelectValue(selected);

    if (callback) callback(value);
  }

  const getValue = selected => {
    if (selected === null) return null;

    return selectedValue || options.filter(item => selected === item[optionValue]);
  }

  return (
    <>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({field: {onChange, value}}) => (
          <div className={`fv-row mb-10${inputClassName ? " " + inputClassName : ""}`}>
            <label className="form-label fs-6 fw-bolder color-dark-grey">
              {label}{required && (<span className="text-danger fw-bolder fs-6"> *</span>)}
            </label>
            <Select
              classNamePrefix="react-select"
              menuPlacement="auto"
              maxMenuHeight={190}
              className={`selectOption ` + className}
              placeholder={placeholder}
              onChange={(selected) => handleChange(selected, onChange)}
              closeMenuOnSelect={true}
              options={options}
              getOptionLabel={(option) => option[optionLabel]}
              getOptionValue={(option) => option[optionValue]}
              value={getValue(value)}
              isMulti={false}
              blurInputOnSelect={false}
              noOptionsMessage={() => " "}
              isClearable={clearable}
            />

            {errorMessage && (
              <div className="fv-plugins-message-container invalid-feedback">
                <div>{errorMessage}</div>
              </div>
            )}
          </div>
        )}
      />
    </>

  )
}